
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 15.6l-8.8-2.1V5c0-.6-.4-1-1-1h-20c-.6 0-1 .4-1 1v22.6c0 .6.4 1 1 1h2.6c.4 1.7 2 3 3.8 3 1.8 0 3.4-1.3 3.8-3h6c.4 1.7 2 3 3.8 3 1.8 0 3.4-1.3 3.8-3h5.7c.6 0 1-.4 1-1v-11c.1-.5-.2-.9-.7-1zm-27.2 11H3.2V6h18.1v17.7c-1.4.4-2.4 1.4-2.8 2.8h-6c-.4-1.7-2-3-3.8-3-1.8 0-3.4 1.4-3.9 3.1zm3.8 2.9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm13.7 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-1 2-2 2zm8.5-2.9h-4.7c-.4-1.4-1.4-2.4-2.8-2.8v-8.2l7.5 1.8v9.2z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M24.6 17.6v3.1l4.8.2v-2.2l-4.8-1.1z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M12.2 20.2a4.6 4.6 0 100-9.2 4.6 4.6 0 000 9.2z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M14.2 16.7c0 .4-.2.7-.4 1-.3.3-.7.4-1.3.5v.9h-.6v-.9c-.7 0-1.3-.1-1.7-.3V17c.2.1.5.2.8.3.3.1.6.1.9.1v-1.6s-1.2-.5-1.4-.8c-.2-.2-.3-.5-.3-.8 0-.4.2-.7.5-1 .3-.3.7-.4 1.2-.5V12h.6v.7c.6 0 1.1.1 1.6.3l-.3.8c-.4-.2-.8-.3-1.3-.3V15l.3.1c.5.2.9.4 1.1.7.2.3.4.6.3.9zm-3-2.5c0 .2.1.3.2.4.1.1.3.2.5.3v-1.3c-.2 0-.4.1-.5.2-.1.1-.2.2-.2.4zm2 2.6c0-.2-.1-.3-.2-.4-.1-.1-.3-.2-.6-.3v1.3c.6-.1.8-.3.8-.6z","fill":"#fff"}})])
          )
        }
      }
    